import { EAssetType, EFeatureFlag } from 'constants/enums';
import { DEFAULT_BORDER_COLOR, PROGRESS_BAR_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { PERCENTAGE_LEFT_ICON, PERCENTAGE_LEFT_ICON_STYLES } from '../FormFields.consts';
import { GradientFieldConfig, NumberFieldConfig, UploadFieldConfig } from '../FormFields.types';

export const FRAME_NUMBER_FIELDS: NumberFieldConfig[] = [
  {
    label: 'Background Opacity',
    name: 'backgroundOpacity',
    min: 0,
    max: 100,
    isRequired: true,
    leftIcon: PERCENTAGE_LEFT_ICON,
    leftIconStyles: PERCENTAGE_LEFT_ICON_STYLES
  },
  { label: 'Frame Radius', name: 'frameRadius', min: 0, isRequired: true }
];

export const BAR_FILL_COLOR_FIELD: GradientFieldConfig = {
  header: 'Bar Fill Color',
  name: 'barFillColor',
  fallback: PROGRESS_BAR_DEFAULTS.barFillColor
};

export const BORDER_GRADIENT_FIELDS: GradientFieldConfig[] = [
  { header: 'Border Color', name: 'borderColor', fallback: DEFAULT_BORDER_COLOR },
  { header: 'Background Color', name: 'barBackgroundColor', fallback: PROGRESS_BAR_DEFAULTS.backgroundColor }
];

export const BAR_NUMBER_FIELDS: NumberFieldConfig[] = [
  { label: 'Bar Radius', name: 'barRadius', min: 0 },
  { label: 'Border Width', name: 'borderWidth', min: 0 }
];

export const UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Accumulated Image',
    fieldName: 'accumulatedItemImageUrl',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload an accumulated item image for the progress bar',
    isRequired: true
  },
  {
    title: 'Accumulated Background Image',
    fieldName: 'accumulatedItemBackgroundImageUrl',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload an accumulated item background image for the progress bar',
    isRequired: true,
    featureFlag: EFeatureFlag.DASHBOARD_PROGRESS_BAR_ACCUMULATED_BG_IMAGE
  },
  {
    title: 'Bar Background Image',
    fieldName: 'barBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a background image for the progress bar',
    featureFlag: EFeatureFlag.DASHBOARD_PROGRESS_BAR_BAR_BG_IMAGE
  },
  {
    title: 'Header Image',
    fieldName: 'headerImage',
    forceType: EAssetType.OFFER_HEADER,
    tooltip: 'Upload a header image for the progress bar',
    featureFlag: EFeatureFlag.DASHBOARD_PROGRESS_BAR_HEADER_IMAGE
  }
];
